// ISO 4217 minor-unit exponents — the one table every "*Minor" amount uses.
//
// A fixed table on purpose, not `Intl`: `maximumFractionDigits` follows the
// runtime's ICU/CLDR display data, which drifts from ISO and between versions —
// HUF is 2 on ICU 77 (Node 20) and 0 on ICU 78 (Node 22, current Chrome). The
// ads sync (packages/marketing, server) and the Ads console (apps/admin,
// browser) must agree on the exponent, or an amount stored as fillér is shown
// and re-typed as forints.

/** ISO 4217 currencies whose exponent is not 2. */
const NON_DEFAULT_EXPONENT: Readonly<Record<string, number>> = {
  BIF: 0,
  CLP: 0,
  DJF: 0,
  GNF: 0,
  ISK: 0,
  JPY: 0,
  KMF: 0,
  KRW: 0,
  PYG: 0,
  RWF: 0,
  UGX: 0,
  UYI: 0,
  VND: 0,
  VUV: 0,
  XAF: 0,
  XOF: 0,
  XPF: 0,
  BHD: 3,
  IQD: 3,
  JOD: 3,
  KWD: 3,
  LYD: 3,
  OMR: 3,
  TND: 3,
  CLF: 4,
  UYW: 4,
};

/** ISO 4217 minor-unit exponent (EUR 2, JPY 0, HUF 2, KWD 3). Unknown / malformed → 2. */
export function currencyExponent(currency: string | null | undefined): number {
  const code = (currency ?? "").trim().toUpperCase();
  if (!/^[A-Z]{3}$/.test(code)) return 2;
  return NON_DEFAULT_EXPONENT[code] ?? 2;
}
